// Here is he structure of a pedigree data
export const PedigreeData = {
    data() {
        return {
            pedigreeStructure: {
                V: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_imported: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VVMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                VMMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                M: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_imported: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MVMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
                MMMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                },
            },
        }
    },

    methods: {
        // Merge a `source` object to a `target` recursively
        merge(target, source) {
            // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
            for (let key of Object.keys(source)) {
                if (source[key] instanceof Object && key in target)
                    Object.assign(source[key], this.merge(target[key], source[key]))
            }

            // Join `target` and modified `source`
            Object.assign(target || {}, source)
            return target
        },
    },
}
